module.exports = __webpack_public_path__ + "static/media/FIAT.15b1b87e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/carBrands/FIAT.png
 ** module id = 1659
 ** module chunks = 0
 **/